import { ActionTree } from 'vuex';
import {
  // ASSOCIATE_DEVICES_TO_TOLLDOMAINS, // TO BE USED LATER
  FETCH_DEVICE_COUNT,
  FETCH_FILTER_PERSONALISATIONS,
  FETCH_PERSONALISATION_DETAILS,
  FETCH_INSTANCENAMES_BY_DEVICE_ID,
  SET_ERROR,
  UPDATE_PERSONALISATIONS_LIST_STATE,
  UPDATE_NAVIGATION,
  PERSO_NAVIGATION,
  PersonalisationState,
  REINIT
} from './types';
import { PersonalisationApiCaller as PersonalisationApi, PersoApiCaller as PersoApi, SearchApiCaller as SearchApi } from './callers';

const actions: ActionTree<PersonalisationState, Record<string, never>> = {
  [REINIT]({ commit }): void {
    commit(REINIT);
  },
  async [FETCH_DEVICE_COUNT]({ commit }, payload) {
    return PersonalisationApi.countPersoTargets(payload.masterId, payload.tolldomainId, payload.status)
      .then((res: any) => {
        commit(FETCH_DEVICE_COUNT, res);
      })
      .catch((res: { message: any; status: any; }) => {
        commit(SET_ERROR, res.message);
        return ({
          notificationStatus: 'error', code: res.status
        });
      });
  },
  [UPDATE_NAVIGATION]({ commit }, payload): void {
    commit(UPDATE_NAVIGATION, payload);
  },
  [PERSO_NAVIGATION]({ commit }, payload): void {
    commit(PERSO_NAVIGATION, payload);
  },
  [FETCH_INSTANCENAMES_BY_DEVICE_ID]({ commit }, payload) {
    return PersonalisationApi.getCurrentPersoInstanceNames(payload.persoTargetType, payload.persoTargetId, payload.masterId)
      .then((res: any) => {
        commit(FETCH_INSTANCENAMES_BY_DEVICE_ID, { deviceID: payload.persoTargetId, instanceNames: res });
      })
      .catch((res: { message: any; status: any; }) => {
        commit(SET_ERROR, res.message);
        return ({
          notificationStatus: 'error', code: res.status
        });
      });
  },
  [FETCH_FILTER_PERSONALISATIONS]({ commit, rootGetters }, navigation) {
    const master = rootGetters['user/getSelectedMasterAccount'];
    if (master.id < 1) return Promise.resolve();
    commit(UPDATE_PERSONALISATIONS_LIST_STATE, {
      view: 'personalisationList',
      stateKey: 'loading',
      stateValue: true
    });
    const {
      devicesPerPage: size = 20, // persoNavigation.ts
      start = 0,
      filters = {}
    } = {
      ...navigation
    };
    return SearchApi.personalisation(master.id, start, size, filters)
      .then((res: any) => {
        commit(UPDATE_PERSONALISATIONS_LIST_STATE, {
          view: 'personalisationList',
          stateKey: 'error',
          stateValue: false
        });
        commit(FETCH_FILTER_PERSONALISATIONS, res);
        commit(UPDATE_PERSONALISATIONS_LIST_STATE, {
          view: 'personalisationList',
          stateKey: 'fetched',
          stateValue: true
        });
      })
      .catch((res: { message: any; status: any; }) => {
        commit(UPDATE_PERSONALISATIONS_LIST_STATE, {
          view: 'personalisationList',
          stateKey: 'error',
          stateValue: true
        });
        commit(SET_ERROR, res.message);
        return ({
          notificationStatus: 'error', code: res.status
        });
      })
      .finally(async () => {
        commit(UPDATE_PERSONALISATIONS_LIST_STATE, {
          view: 'personalisationList',
          stateKey: 'loading',
          stateValue: false
        });
      });
  },
  [FETCH_PERSONALISATION_DETAILS]({ commit, rootGetters }, payload) {
    const master = rootGetters['user/getSelectedMasterAccount'];
    if (master.id < 1) return Promise.resolve();

    return PersoApi.getPersonalisationDisplayDetails(payload.type, payload.id, master.id, payload.version)
      .then((res: any) => {
        commit(FETCH_PERSONALISATION_DETAILS, { id: payload.id, details: res });
      })
      .catch((res: { message: any; status: any; }) => {
        commit(SET_ERROR, res.message);
        return ({
          notificationStatus: 'error', code: res.status
        });
      });
  }
};
export default actions;
